export default [
  {
    id: '200899',
    firstName: 'Greendale',
    lastName: 'Auditor',
    email: 'greendale@getshowbie.test',
    purchaserId: '10002',
  },
  {
    id: '1200199',
    firstName: 'Athabasca High',
    lastName: 'Auditor',
    email: 'athabasca@getshowbie.test',
    purchaserId: '12001',
  },
];
